import withNavigate from "../../../routes/withNavigate.jsx";

import AttendenceReportsContainer from "./AttendenceReportsContainer.jsx";
import AttendenceReportsStore from "./AttendenceReportsStore.js";

export default AttendenceReportsStore(
    withNavigate(AttendenceReportsContainer)
);